<template>
  <div class="modal-events" :style="{ top: `${top}px` }">
    <div class="content-events">
      <span class="close" @click="$emit('input', false)">
        Fechar <XIcon/>
      </span>

      <h3 class="mt-5">Chave de Acesso:</h3>
      <p>
        {{ fiscalDocument.key }}
        <CopyIcon @click="copyKey(fiscalDocument.key)" class="fd-icon ml-1" v-tooltip.bottom="'Copiar'"/>
      </p>
      <hr>

      <p><strong>Status da nota:</strong> {{ fiscalDocument.lastEvent }}</p>
      <p><strong>Entrou na plataforma em:</strong> {{ fiscalDocument.includedAt | datetime }}</p>
      <p><strong>Atualizado em:</strong> {{ fiscalDocument.updatedAt | datetime }}</p>
  
      <h4 v-if="load" class="mt-5 text-center text-blink">
        Procurando eventos...
      </h4>
      
      <h4 v-else-if="events.length === 0" class="mt-5 text-center">
        Sem eventos
      </h4>

      <div class="row mb-3" v-for="event in events" :key="event.id">
        <div class="col-md-6">

          <div class="datetime">
            <div class="nowrap ml-2">
              {{ event.eventDate | datetime }}
            </div>
            <div class="arrow-down-icon" :class="{'arrow-down-icon-input': event.input }">
              <ArrowDownIcon v-if="event.input" class="ml-1"/>
              <ArrowUpIcon v-else class="ml-1 rotation-down"/>
            </div>
          </div>
          <div class="vl  mt-1 mr-3 float-right"></div>

        </div>

        <div class="col-md-6">
          <div class="infos">
            <p><strong>Usuário:</strong> {{ event.userEmail }}</p>
            <p v-for="([attribute, name]) in attributes" :key="attribute">
              <template v-if="event[attribute]">
                <strong>{{ name }}:</strong> {{ event[attribute] }}
              </template>
            </p>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
  import { ArrowDownIcon, ArrowUpIcon, XIcon } from 'vue-feather-icons'
  import { CopyIcon } from 'vue-feather-icons'
  import { mapMutations } from 'vuex';

  export default {
    beforeDestroy() {
      this.elementMain.style.overflow = this.overflowBackup
    },
    components: { ArrowDownIcon, ArrowUpIcon, CopyIcon, XIcon },
    created() {
      this.openGlobalLoad()
      
      this.axios.get(`dfe/fiscal_documents/${this.fiscalDocument.id}/events`)
        .then(response => this.$parse.toCamelcase(response.data))
        .then(data => this.events = data)
        .finally(() => this.closeLoad())
    },
    data() {
      return {
        attributes: [
          ['code', 'Código'],
          ['description', 'Descrição'],
          ['protocol', 'Protocolo'],
          ['detail', 'Detalhes']
        ],
        events: [],
        load: true,
        top: 0
      }
    },
    methods: {
      ...mapMutations(['openGlobalLoad', 'closeGlobalLoad']),
      closeLoad() {
        this.load = false
        this.closeGlobalLoad()
      },
      copyKey(key) {
        const input = document.createElement('input');
        input.value = key
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
      }
    },
    mounted() {
      this.elementMain = document.querySelector('.home > main')
      this.overflowBackup = this.elementMain.style.overflow
      this.top = this.elementMain.scrollTop
      this.elementMain.style.overflow = 'hidden'
    },
    name: 'ModalEvents',
    props: {
      fiscalDocument: { required: true, type: Object },
      value: { required: true, type: Boolean }
    }
  }
</script>

<style scoped>

  .modal-events {
    position: absolute;
    background: #2B2B2BBB;
    left: -2px;
    width: 100%;
    height: 100%;
    z-index: 5;
    margin-left: 4px;
  }

  .content-events {
    height: 100%;
    width: 45%;
    background: var(--white-bg);
    overflow: auto;
    padding: 24px;
    color: var(--primary-text-color);
  }

  .content-events h3,
  .content-events h4,
  .content-events p {
    color: var(--primary-text-color);
  }

  .datetime {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    height: 32px;
    background: var(--background-tab);
    box-shadow: 0px 2px 2px rgba(5, 27, 48, 0.15);
    border-radius: 50px;
    color: var(--primary-text-color);
  }

  .arrow-down-icon {
    height: 100%;
    width: 36px;
    border-radius: 0 50px 50px 0;
    color: #FFF;
    background: #318BE3;
    padding: 0;
  }

  .rotation-down{
    transform: rotate(42.94deg);
  }

  .rotation-up{
    transform: rotate(-137.73deg);
  }

  .arrow-down-icon > svg {
    height: 100%;
    transform: rotate(42.94deg);
  }

  .arrow-down-icon-input {
    background: #15CE9A;
  }

  .infos {
    background: var(--background-tab);
    border-radius: 5px;
    padding: 8px;
    box-shadow: 0px 2px 2px rgba(5, 27, 48, 0.15);
  }

  .infos p {
    color: var(--primary-text-color);
  }

  .fd-icon {
    cursor: pointer;
    padding: 4px 0;
    border-radius: 5px;
  }

  .fd-icon:active {
    background: #15CE9A;
  }

  .vl {
    border-left: 2px solid #d9d9d9;
    height: 200px;
  }
  
  .close {
    cursor: pointer;
  }

  @keyframes text-blink {
    0% { opacity: 1; }
    50% { opacity: 0.5; }
    100% { opacity: 0; }
  }
  .text-blink {
    -webkit-animation: text-blink 1.25s linear infinite;
    -moz-animation: text-blink 1.25s linear infinite;
    -ms-animation: text-blink 1.25s linear infinite;
    -o-animation: text-blink 1.25s linear infinite;
    animation: text-blink 1.25s linear infinite;
  }

</style>
